export default "/images/delete-icon.svg?62c72530c1972caf0ed2639894c8d056";